import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('admin/manage-account?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('admin/manage-account/show/'+id);
    },    
    store(params) {
        return Service().post('admin/manage-account/store', params);
    },
    update(id, params) {
        return Service().post('admin/manage-account/update/'+id, params);
    },
    delete(id) {
        return Service().post('admin/manage-account/delete/'+id);
    }
}